// Состав стартовых страниц по кодам наборов (те же коды, что НАБОРЫ в web/bff/rights.py).
//
// У каждого профиля свой «дух» — с какого портала человек приходит и что привык видеть
// первым: инженер — с 73, координатор — с брифа, коммерция — с 55, бухгалтерия — с БУХ,
// руководство — с exec. Дизайн у всех один (тема 55, решение владельца), различается
// состав дверей.
//
// Коды «координатор» и «админ» появятся в rights.py от основной сессии — вёрстка здесь
// сделана по строке set и жёстко существования кода не проверяет: незнакомый код — не
// ошибка, а сводка по умолчанию (BFF заведёт новый набор раньше, чем обновится фронт).
//
// Разделы плиток ОБЯЗАНЫ совпадать с rights.РАЗДЕЛЫ: по коду `раздел` сводка решает,
// показывать ли плитку (предикат denied() — тот же, что у меню). Счётчики — только коды
// из реестра СЧЁТЧИКИ (tiles.tsx), то есть только существующие ручки BFF.

import type { Сводка55 } from './types'

export const СВОДКИ: Record<string, Сводка55> = {
  инженер: {
    заголовок: 'Инженерия',
    врезка: 'Работы по судам и ваши задания — как на портале 73. Деньги за работу — в личном кабинете.',
    плитки: [
      { to: '/verifications', раздел: 'verifications', ic: '🛰', b: '73', счётчик: 'verifications',
        t: 'Мои верификации', d: 'верификации судов из зеркала 73: статус, тип, фото' },
      { to: '/job-reports', раздел: 'job-reports', ic: '📋', b: '73', счётчик: 'job-reports',
        t: 'Отчёты по заявкам', d: 'что сделано по заявкам и что ещё не закрыто' },
      { to: '/engineer-schedule', раздел: 'engineer-schedule', ic: '📅',
        t: 'Календарь инженеров', d: 'кто на каком судне и в какие дни; отпуска учтены' },
      { to: '/deals', раздел: 'deals', ic: '🗂', b: 'Bitrix', счётчик: 'deals',
        t: 'Мои сделки', d: 'сделки в работе — внутри раздела' },
      { to: '/gratitude', раздел: 'gratitude', ic: '💌', b: '73',
        t: 'Благодарности', d: 'кого отметил заказчик и какие значки у человека' },
    ],
  },
  координатор: {
    заголовок: 'Координация',
    врезка: 'Сделки, верификации и проекты — как на брифинге, только за логином CRM.',
    плитки: [
      { to: '/deals', раздел: 'deals', ic: '🗂', b: 'Bitrix', счётчик: 'deals',
        t: 'Сделки в работе', d: 'по стадиям — внутри раздела' },
      { to: '/verifications', раздел: 'verifications', ic: '🛰', b: '73', счётчик: 'verifications',
        t: 'Верификации', d: 'верификации судов из зеркала 73' },
      { to: '/coord-projects', раздел: 'coord-projects', ic: '📁', b: 'бриф', счётчик: 'coord-projects',
        t: 'Проекты координатора', d: 'карточки проектов с брифинга: чек-лист, вехи, журнал' },
      { to: '/engineer-schedule', раздел: 'engineer-schedule', ic: '📅',
        t: 'Календарь инженеров', d: 'кто на каком судне и в какие дни' },
      { to: '/receivables', раздел: 'receivables', ic: '💰', b: 'своё', счётчик: 'receivables',
        t: 'Дебиторка', d: 'счета с непогашенным остатком' },
    ],
  },
  коммерция: {
    заголовок: 'Коммерция',
    врезка: 'Сделки, счета и долги — те же числа, что в самих разделах.',
    плитки: [
      { to: '/deals', раздел: 'deals', ic: '🗂', b: 'Bitrix', счётчик: 'deals',
        t: 'Мои сделки', d: 'в работе, по стадиям — внутри раздела' },
      { to: '/receivables', раздел: 'receivables', ic: '📊', b: 'своё', счётчик: 'receivables',
        t: 'Дебиторка и просрочка', d: 'счета с непогашенным остатком' },
      { to: '/smart/invoices', раздел: 'invoices', ic: '🧾', b: 'Bitrix', счётчик: 'invoices',
        t: 'Счета клиенту', d: 'какие счета мы выставили' },
      { to: '/sales-rating', раздел: 'sales-rating', ic: '🏆',
        t: 'Рейтинг ОП', d: 'кто сколько закрыл за период' },
    ],
  },
  бухгалтерия: {
    заголовок: 'Бухгалтерия',
    врезка: 'Банк, счета в обе стороны и здоровье данных — как на портале БУХ.',
    плитки: [
      { to: '/bank', раздел: 'bank', ic: '🏦', b: 'банк',
        t: 'Банк и бухгалтерия', d: 'выписка расчётного счёта, сальдо и неразнесённое' },
      { to: '/smart/payment-calendar', раздел: 'payment-calendar', ic: '💳', b: 'Bitrix',
        счётчик: 'payment-calendar',
        t: 'Счета на оплату', d: 'что согласовано к оплате поставщикам' },
      { to: '/data-quality', раздел: 'data-quality', ic: '🧪',
        t: 'Качество данных', d: 'чему в зеркале нельзя верить и где это чинится' },
      { to: '/xreports', раздел: 'xreports', ic: '🔀',
        t: 'Сквозные отчёты', d: 'деньги без разноски, оплаты без документов, работы без счёта' },
    ],
  },
  руководство: {
    заголовок: 'Руководство',
    врезка: 'Свод по деньгам и работе — как в кабинете exec; подробности в самих разделах.',
    плитки: [
      { to: '/reports', раздел: 'reports', ic: '📈',
        t: 'Отчёты руководителя', d: 'переносы срока оплаты, динамика долга, возраст ошибок' },
      { to: '/receivables', раздел: 'receivables', ic: '💰', b: 'своё', счётчик: 'receivables',
        t: 'Дебиторка', d: 'счета с непогашенным остатком' },
      { to: '/nelikvid', раздел: 'nelikvid', ic: '📦', b: '1С',
        t: 'Неликвиды', d: 'что лежит на складах и не двигается' },
      { to: '/analytics', раздел: 'analytics', ic: '📊',
        t: 'Аналитика продаж', d: 'выручка и сделки по месяцам, воронкам и отделам' },
      { to: '/sales-rating', раздел: 'sales-rating', ic: '🏆',
        t: 'Рейтинг ОП', d: 'кто сколько закрыл за период' },
    ],
  },
  админ: {
    заголовок: 'Администрирование',
    врезка: 'Общий свод и служебные разделы: система, учётки, задания процессов.',
    плитки: [
      { to: '/deals', раздел: 'deals', ic: '🗂', b: 'Bitrix', счётчик: 'deals',
        t: 'Сделки в работе', d: 'по всей базе — внутри раздела' },
      { to: '/receivables', раздел: 'receivables', ic: '💰', b: 'своё', счётчик: 'receivables',
        t: 'Дебиторка', d: 'счета с непогашенным остатком' },
      { to: '/bp-tasks', раздел: 'bp-tasks', ic: '⚙️', b: 'Bitrix', счётчик: 'bp',
        t: 'Задания процессов', d: 'чьё задание висит и сколько висит' },
      { to: '/health', раздел: 'health', ic: '🩺', b: 'ядро', счётчик: 'health',
        t: 'Состояние системы', d: 'можно ли доверять данным прямо сейчас' },
      { to: '/admin/users', раздел: 'admin-users', ic: '🔐',
        t: 'Учётки и доступ', d: 'роли, наборы, блокировки и выдача паролей' },
    ],
  },
  // Наборы, которые уже были у сводки до перехода на тему 55, — им нельзя выпасть
  // в «сводку по умолчанию» при обновлении фронта.
  снабжение: {
    заголовок: 'Снабжение и закупки',
    врезка: 'Что согласовано к оплате, что на складе и что ждёт отгрузки.',
    плитки: [
      { to: '/smart/payment-calendar', раздел: 'payment-calendar', ic: '💳', b: 'Bitrix',
        счётчик: 'payment-calendar',
        t: 'Счета на оплату', d: 'что согласовано к оплате поставщикам' },
      { to: '/bp-tasks', раздел: 'bp-tasks', ic: '⚙️', b: 'Bitrix', счётчик: 'bp',
        t: 'Задания процессов', d: 'согласования и заполнение данных' },
      { to: '/purchasing', раздел: 'purchasing', ic: '📥',
        t: 'Кабинет закупщика', d: 'заявки на оплату: что согласовано, что просрочено' },
      { to: '/stock', раздел: 'stock', ic: '📦', b: '1С',
        t: 'Склад', d: 'есть ли позиция, сколько свободно и где' },
      { to: '/shipping', раздел: 'shipping', ic: '🚚', b: '1С',
        t: 'Отгрузка', d: 'что отгружено и что ждёт отгрузки' },
    ],
  },
  офис: {
    заголовок: 'Офис',
    врезка: 'Люди, календари и задания — без денег и без инженерных форм.',
    плитки: [
      { to: '/bp-tasks', раздел: 'bp-tasks', ic: '⚙️', b: 'Bitrix', счётчик: 'bp',
        t: 'Задания процессов', d: 'чьё задание висит и сколько висит' },
      { to: '/absence', раздел: 'absence', ic: '🏖',
        t: 'Отсутствия', d: 'кто в отпуске, на больничном или в командировке' },
      { to: '/calendar', раздел: 'calendar', ic: '📆', b: 'Bitrix',
        t: 'Календарь', d: 'встречи и события: день и неделя по людям' },
      { to: '/engineer-schedule', раздел: 'engineer-schedule', ic: '📅',
        t: 'Календарь инженеров', d: 'кто на каком судне и в какие дни' },
      { to: '/contacts', раздел: 'contacts', ic: '👥', b: 'Bitrix',
        t: 'Контакты', d: 'найти человека и его компанию' },
    ],
  },
}

/** Сводка для незнакомого кода набора: без счётчиков не остаёмся, показываем общее. */
export const СВОДКА_ПО_УМОЛЧАНИЮ: Сводка55 = {
  заголовок: 'Сводка',
  врезка: 'Ваш набор разделов новее этой сборки CRM — показано общее. Меню слева полное.',
  плитки: [
    { to: '/deals', раздел: 'deals', ic: '🗂', b: 'Bitrix', счётчик: 'deals',
      t: 'Сделки в работе', d: 'по стадиям — внутри раздела' },
    { to: '/bp-tasks', раздел: 'bp-tasks', ic: '⚙️', b: 'Bitrix', счётчик: 'bp',
      t: 'Задания процессов', d: 'чьё задание висит и сколько висит' },
  ],
}
